var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partner"},[_c('div',{staticClass:"commonwealBanner"}),_c('Sos'),_c('SosForm'),_c('HomeFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }